export default "__VITE_ASSET__DBVTDTjM__"